module.exports = __webpack_public_path__ + "media/images/noimage-writer@3x-c95a39c748f415aeb2689d7f591272f6.png";